import { LazyModule } from 'owa-bundling';
import { runAfterBootstrap } from 'owa-delayed-initialization';
// Import orchestrators so they get registered
import './orchestrators/multiselectNextRowOrchestrator';
import './orchestrators/multiselectPreviousRowOrchestrator';
import './orchestrators/rangeSelectRowOrchestrator';
import './orchestrators/resetSelectionOrchestrator';
import './orchestrators/selectNextRowOrchestrator';
import './orchestrators/selectPreviousRowOrchestrator';
import './orchestrators/singleSelectRowOrchestrator';
import './orchestrators/toggleSelectAllRowsOrchestrator';
import './orchestrators/toggleSelectRowOrchestrator';
import './mutators/setSelectionOnRowMutator';
import './mutators/resetSelectionOnTableMutator';
export var lazyModule = new LazyModule(function () {
    return System.import(
    /* webpackChunkName: "ExpandedListSelectionActions" */ './lazyIndex');
});
runAfterBootstrap(function () {
    lazyModule.import();
});
//# sourceMappingURL=index.js.map